import React from "react";

import { Helmet } from "react-helmet";
import "./LandingPage.css";
import Home from "./components/Home";
import About from "./components/About";
import Services from "./components/Services";
import Portfolio from "./components/Portfolio";
import Contact from "./components/Contact";
import { useLandingPage } from "./_hooks/useLandingPage";
import Header from "./components/Header";

export default function LandingPage() {
  const {
    isSticky,
    isMenuActive,
    handleMenuClick,
    activeSection,
    toggleTheme,
    currentTheme,
  } = useLandingPage();

  return (
    <div>
      <Helmet>
        <link
          href="https://unpkg.com/boxicons@2.1.4/css/boxicons.min.css"
          rel="stylesheet"
        />
        <title>Althaf Hussain Portfolio</title>
      </Helmet>

      <Header
        isSticky={isSticky}
        currentTheme={currentTheme}
        toggleTheme={toggleTheme}
        handleMenuClick={handleMenuClick}
        activeSection={activeSection}
        isMenuActive={isMenuActive}
      />

      {/* Home Component */}
      <section id="home">
        <Home />
      </section>

      {/* About Component */}
      <section id="about">
        <About />
      </section>

      {/* Services Component */}
      <section id="services">
        <Services />
      </section>

      {/* Portfolio Component */}
      <section id="portfolio">
        <Portfolio />
      </section>

      {/* Contact Component */}
      <section id="contact">
        <Contact />
      </section>
    </div>
  );
}
